import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { useSubscriptionStore } from '../stores/subscriptionStore';
import { MainLayout } from './layout';
import { HeroScreen } from '../screens/HeroScreen';
import { PaywallScreen } from '../screens/PaywallScreen';
const PUBLIC_PATHS = ['/faq', '/about', '/privacy'];

const PublicLayout = ({ children }: { children: React.ReactNode }) => (
  <div style={{ minHeight: '100vh', padding: 'var(--space-lg)' }}>
    {children}
  </div>
);

export const AuthGuard = () => {
  const { isAuthenticated, isInitialized, isLoading } = useAuthStore();
  const { isActive: isSubscribed, isLoading: isSubLoading } = useSubscriptionStore();
  const location = useLocation();
  const pathname = location.pathname;

  if (!isInitialized || isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    if (pathname === '/') {
      return <HeroScreen />;
    }
    if (PUBLIC_PATHS.includes(pathname)) {
      return (
        <PublicLayout>
          <Outlet />
        </PublicLayout>
      );
    }
    return <Navigate to="/" replace />;
  }

  const showPaywall = !isSubscribed && !isSubLoading;
  if (showPaywall) {
    return <PaywallScreen />;
  }

  return <MainLayout />;
};
